export default "__VITE_ASSET__b83ea98d__"